import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import InputFields from 'routes/Pages/components/InputFields/InputFields';

const UploadFiles = ({ files, label, handleDeleteFile, viewFile, handleFileUpload }) => {
  return (
    <Box sx={{ ml: 2, mt: 1 }}>
      <InputFields
        label={label ?? 'Upload Files (Upload Image of screen or relevant documents)'}
        helperText={'Upload Relevant Documents'}
        name="documents"
        textFieldType={'file'}
        width={8}
        handleIpChange={handleFileUpload}
      />
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 1,
          py: 1,
          px: 0.5,
          alignItems: 'center',
          minHeight: 60,
        }}>
        {files &&
          files?.length > 0 &&
          files.map((file, index) => (
            <Tooltip title={file.docName} key={index}>
              <div>
                <Chip
                  label={file.docName.length > 20 ? file.docName.slice(0, 18) + '…' : file.docName}
                  color="success"
                  sx={{
                    fontSize: '0.7rem',
                    height: '24px',
                    px: 1,
                  }}
                  onDelete={() => handleDeleteFile(file)}
                  onClick={() => viewFile(file)}
                />
              </div>
            </Tooltip>
          ))}
      </Box>
    </Box>
  );
};

export default UploadFiles;
